import { IChain, IModel } from "makerjs";
import { ValidatorInterface } from "./ValidatorInterface";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import {
	CutoutMoveDecorator,
	InterfaceModelDecorator,
	ShapeModelDecorator,
} from "@/utilities/decorators/PreviewModelDecorator";
import { CutoutRotationDecorator } from "@/utilities/decorators/CutoutRotationDecorator";
import Cutout from "../Cutout";

export class CutoutNoEffectValidator implements ValidatorInterface {

	constructor(
		private baseModel: IModel,
		private cutouts: Cutout[]
	) {}

	getMessage(): string {
		const { cutout: cutoutValidatorMessages } =
			window.measurementSelectorVariables.i18n.validators;

		return (
			cutoutValidatorMessages.cutoutIncorrect ??
			"Cutout is incorrect. Please check the dimensions or position"
		);
	}

	isValid(): boolean {
		const baseModel = makerjs.model.clone(this.baseModel);
		let compareModel = makerjs.model.clone(baseModel);
		let isValid = true;

		this.cutouts.forEach((cutout: Cutout, index: number) => {
			let modelDecorator: InterfaceModelDecorator;
			modelDecorator = new ShapeModelDecorator(null, cutout.instance);
			modelDecorator = new CutoutMoveDecorator(modelDecorator, cutout, baseModel);
			modelDecorator = new CutoutRotationDecorator(modelDecorator, cutout);

			const originalCutoutModel = modelDecorator.getModel();
			const cutoutModel = makerjs.model.clone(originalCutoutModel);
			const originalCompareModel = makerjs.model.clone(compareModel);

			const newModel = makerjs.model.combineSubtraction(
				compareModel,
				cutoutModel
			);

			makerjs.model.zero(newModel);
			makerjs.model.originate(newModel);

			const newModelChains = makerjs.model.findChains(newModel) as IChain[];
			const compareModelChains = makerjs.model.findChains(originalCompareModel) as IChain[];

			// Possible invalid because the number of chains is the same, so the cutout has no effect
			if (newModelChains.length === compareModelChains.length) {
				isValid = false;

				for (let chainIndex = 0; chainIndex < newModelChains.length; chainIndex++) {
					const chain = newModelChains[chainIndex];

					// If the path length is different, then the cutout has an effect
					if (chain.pathLength !== compareModelChains[chainIndex].pathLength) {
						isValid = true;
					}
				}
			} else {
				isValid = true;
			}

			compareModel = makerjs.model.clone(newModel);
		});

		return isValid;
	}
}
